import React from "react";
import { t } from "i18next";
import {
  Layout,
  Typography,
  Row,
  Col,
  Card,
  Divider,
  Image,
  Carousel,
  Breadcrumb,
} from "antd";
import { NavLink } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import img from "../../assets/articles.jpg";
import img1 from "../../assets/ab-1.png";
import img2 from "../../assets/ab-2.png";
import img3 from "../../assets/ab-3.png";

import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const Articles = () => {
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["articles-title"]}>Articles</Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img} alt="Executive" className="responsive-image" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Page currently under development, come back soon
                </div>
                <Paragraph
                  className={s["main-carusel-description"]}
                ></Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        
      </Content>
    </Layout>
  );
};
